<div class="ui-login">
    <div class="ui-login-area">
        <div class="ui-login-logo"></div>

        <div class="ui-login-form">
            <form>
                <div class="ui-login-message" *ngIf="response">{{response.message}}</div>

                <mat-form-field class="ui-field">
                    <mat-label>Email</mat-label>
                    <input matInput type="text" name="user" [(ngModel)]="user">
                </mat-form-field>
                <mat-form-field class="ui-field ui-field-password">
                    <mat-label>Contraseña</mat-label>
                    <input matInput [attr.type]="(passwordVisibility ? 'text' : 'password')" name="password" [(ngModel)]="password">
                    <mat-icon class="ui-icon" matSuffix (click)="passwordVisibility = !passwordVisibility">{{(passwordVisibility ? 'visibility_off' : 'visibility_on')}}</mat-icon>
                </mat-form-field>

                <!--<div class="ui-login-form-actions">
                    <a (click)="setLocation('recuperar')">Olvidé mi contraseña</a>
                </div>-->
                
                <div class="ui-login-form-button">
                    <button type="submit" mat-flat-button color="primary" class="ui-button" (click)="onLogin()" *ngIf="!request">Ingresar</button>
                    <mat-spinner class="ui-spinner" [diameter]="36" *ngIf="request"></mat-spinner>
                </div>

                <mat-icon class="ui-icon ui-biometric-icon" (click)="biometricAuth()" *ngIf="biometricAvailable">fingerprint</mat-icon>
            </form>
        </div>
    </div>

    <a class="ui-developer" (click)="onDevInfo()">
        <img src="assets/images/clousis.svg" title="Desarrollador">
    </a>
</div>